export enum FarmCatalogueTab {
  FLOWERS = "myfarm_shop_flower",
  TREES = "myfarm_shop_tree",
  HAMMERS = "myfarm_shop_hammer",
  WHEELBARROWS = "myfarm_shop_wheelbarrow",
  FENCES = "myfarm_shop_fence",
  CROWNS = "myfarm_shop_premium",
  HOUSE = "myfarm_shop_house",
}
